<div class="cv-maps-root">
  <div
    *ngIf="swipeEmptyNotice() as notice"
    class="cv-canvas-toast"
    role="status"
    aria-live="polite"
  >
    {{ notice }}
  </div>

  <div
    *ngIf="bboxSearchNotice() as bboxNotice"
    class="cv-canvas-toast cv-canvas-toast--bbox"
    role="status"
    aria-live="polite"
  >
    {{ bboxNotice }}
  </div>

  <lib-canvas-bbox-search-banner
    *ngIf="mapVisible"
    [visible]="bboxSearchSummaryVisible()"
    [resourceCount]="bboxSearchHits().length"
    [selectedCount]="bboxSelectedCount()"
    (listAllResults)="openBboxResultsList()"
    (clearBbox)="cancelBboxSearch()"
    (backToDatasets)="onBboxBannerBackToDatasets()"
  ></lib-canvas-bbox-search-banner>

  <div
    *ngIf="bboxSearchLoading()"
    class="cv-bbox-loader"
    role="status"
    aria-live="polite"
  >
    <span class="cv-bbox-loader__spinner" aria-hidden="true"></span>
    <span class="cv-bbox-loader__text">Loading features…</span>
  </div>

  <!-- Layers widget: morphs from icon button → expanded panel card -->
  <div
    class="cv-layers-widget"
    [class.cv-layers-widget--open]="isLayerPanelOpen()"
    *ngIf="mapVisible"
  >
    <!-- Header row — always visible; acts as trigger -->
    <div
      class="cv-layers-widget__header"
      (click)="toggleLayerPanel()"
      role="button"
      [attr.aria-expanded]="isLayerPanelOpen()"
      tabindex="0"
      (keydown.enter)="toggleLayerPanel()"
      (keydown.space)="toggleLayerPanel()"
      title="Toggle layers panel"
    >
      <!-- Layers stack icon -->
      <svg
        class="cv-layers-widget__icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <polygon points="12 2 2 7 12 12 22 7 12 2" />
        <polyline points="2 17 12 22 22 17" />
        <polyline points="2 12 12 17 22 12" />
      </svg>

      <span class="cv-layers-widget__title">Layers</span>

      <span
        class="cv-layers-widget__count"
        *ngIf="drawnLayerEntries().length > 0"
        [attr.aria-label]="drawnLayerEntries().length + ' layers'"
        >{{ drawnLayerEntries().length }}</span
      >

      <button
        *ngIf="isLayerPanelOpen() && drawnLayerEntries().length > 0"
        class="cv-layers-widget__clear-all"
        type="button"
        (click)="$event.stopPropagation(); onClearAllLayers()"
        aria-label="Clear all layers"
        title="Clear all"
      >
        <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M9 3V4H4V6H5V19C5 20.1 5.9 21 7 21H17C18.1 21 19 20.1 19 19V6H20V4H15V3H9ZM7 6H17V19H7V6ZM9 8V17H11V8H9ZM13 8V17H15V8H13Z"/>
        </svg>
      </button>

      <!-- Collapse-panel icon — visible only when open -->
      <button
        *ngIf="isLayerPanelOpen()"
        class="cv-layers-widget__close"
        type="button"
        (click)="$event.stopPropagation(); toggleLayerPanel()"
        aria-label="Close layers panel"
        title="Close"
      >
        <svg
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
          stroke-width="1.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <rect x="2" y="2" width="16" height="16" rx="3" />
          <line x1="7" y1="2" x2="7" y2="18" />
          <polyline points="12 7 9.5 10 12 13" />
        </svg>
      </button>
    </div>

    <!-- Body — slides down after width expands -->
    <div class="cv-layers-widget__body" *ngIf="isLayerPanelOpen()">
      <lib-canvas-layers-panel
        [layers]="drawnLayerEntries()"
        [showHeader]="false"
        [iconsBaseUrl]="iconsBaseUrl"
        (closePanel)="toggleLayerPanel()"
        (toggleVisibility)="onToggleDrawnLayer($event)"
        (nameChange)="onDrawnLayerNameChange($event)"
        (saveName)="onSaveDrawnLayerName($event)"
        (resetToDefault)="onResetDrawnLayerToDefault($event)"
        (deleteLayer)="onDeleteDrawnLayer($event)"
        (exportLayer)="onLayerExport($event)"
        (zoomToBounds)="onLayerZoomToBounds($event)"
        (aboutLayer)="onLayerAbout($event)"
        (startEditName)="onStartEditDrawnLayerName($event)"
        (layerColorChange)="onLayerColorChange($event.id, $event.color)"
        (layerMarkerChange)="onLayerMarkerChange($event.id, $event.iconId)"
        (layerOpacityChange)="onLayerOpacityChange($event.id, $event.opacity)"
        (reorderLayers)="onReorderLayers($event)"
        (clearAllLayers)="onClearAllLayers()"
        (layerSelect)="onLayerSelect($event)"
      ></lib-canvas-layers-panel>
    </div>
  </div>

  <div #mapContainer class="cv-map" [class.cv-map--hidden]="!mapVisible"></div>

  <div
    *ngIf="basemapLoading()"
    class="cv-basemap-loader"
    role="status"
    aria-live="polite"
  >
    <span class="cv-basemap-loader__spinner" aria-hidden="true"></span>
    <span class="cv-basemap-loader__text">Loading base map...</span>
  </div>

  <div *ngIf="mapVisible" class="cv-zoom">
    <button
      class="cv-zoom__btn"
      (click)="zoomOut()"
      title="Zoom out"
      type="button"
    >
      <svg
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
      >
        <line x1="5" y1="12" x2="19" y2="12" />
      </svg>
    </button>
    <span class="cv-zoom__label">{{ zoomPercent }}%</span>
    <button
      class="cv-zoom__btn"
      (click)="zoomIn()"
      title="Zoom in"
      type="button"
    >
      <svg
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
      >
        <line x1="12" y1="5" x2="12" y2="19" />
        <line x1="5" y1="12" x2="19" y2="12" />
      </svg>
    </button>
  </div>

  <lib-canvas-toolbar
    *ngIf="mapVisible && map"
    [map]="map"
    [userDrawSource]="userDrawSource"
    [addPointActive]="addPointToolActive()"
    [selectActive]="selectToolActive()"
    [swipeActive]="swipeActive()"
    [measureActive]="measureToolActive()"
    (selectTool)="onSelectTool()"
    (locate)="onLocate()"
    (openDatasets)="openDatasetsModal()"
    (search)="onCanvasSearch($event)"
    (drawShape)="onDrawShape($event)"
    (addPoint)="onAddPoint()"
    (measure)="onMeasure()"
    (swipe)="openSwipeDialog()"
    (featuresImported)="onFeaturesImported($event)"
    [hasExistingLayers]="drawnLayerEntries().length > 0"
    [exportLayers]="getCanvasExportLayers"
    [basemaps]="basemapOptions"
    [activeBasemap]="activeBasemap()"
    (basemapChange)="onBasemapChange($event)"
  ></lib-canvas-toolbar>

  <!-- Swipe setup panel — pick which layers go on each side (multi-select checkboxes) -->
  <div
    class="cv-swipe-setup"
    *ngIf="swipeDialogOpen()"
    role="dialog"
    aria-modal="true"
  >
    <div class="cv-swipe-setup__header">
      <svg
        class="cv-swipe-setup__icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.9"
        stroke-linecap="round"
      >
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <line x1="12" y1="3" x2="12" y2="21" />
      </svg>
      <span class="cv-swipe-setup__title">Compare Layers</span>
      <button
        type="button"
        class="cv-swipe-setup__close"
        (click)="swipeDialogOpen.set(false)"
        aria-label="Close"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>

    <!-- Column headers -->
    <div class="cv-swipe-setup__cols">
      <span class="cv-swipe-setup__col-hdr cv-swipe-setup__col-hdr--left"
        >Left</span
      >
      <span class="cv-swipe-setup__col-hdr cv-swipe-setup__col-hdr--layer"
        >Layer</span
      >
      <span class="cv-swipe-setup__col-hdr cv-swipe-setup__col-hdr--right"
        >Right</span
      >
    </div>

    <!-- One row per layer, tick left / right independently -->
    <div class="cv-swipe-setup__rows">
      <div
        class="cv-swipe-setup__row"
        *ngFor="let layer of drawnLayerEntries()"
      >
        <label class="cv-swipe-setup__check cv-swipe-setup__check--left">
          <input
            type="checkbox"
            [checked]="swipeLeftIds().includes(layer.id)"
            (change)="toggleSwipeLeft(layer.id)"
            [attr.aria-label]="'Left: ' + layer.name"
          />
          <span class="cv-swipe-setup__tick"></span>
        </label>

        <span class="cv-swipe-setup__layer-name">{{ layer.name }}</span>

        <label class="cv-swipe-setup__check cv-swipe-setup__check--right">
          <input
            type="checkbox"
            [checked]="swipeRightIds().includes(layer.id)"
            (change)="toggleSwipeRight(layer.id)"
            [attr.aria-label]="'Right: ' + layer.name"
          />
          <span class="cv-swipe-setup__tick"></span>
        </label>
      </div>
    </div>

    <button type="button" class="cv-swipe-setup__apply" (click)="applySwipe()">
      Start comparing
    </button>
  </div>

  <!-- Comparison bar — shows which layers are on each side while swipe is active -->
  <div class="cv-swipe-bar" *ngIf="swipeActive()">
    <span class="cv-swipe-bar__name cv-swipe-bar__name--left">
      <svg viewBox="0 0 8 8">
        <circle cx="4" cy="4" r="3" fill="currentColor" />
      </svg>
      {{ swipeLayerNames(swipeLeftIds()) }}
    </span>
    <button
      type="button"
      class="cv-swipe-bar__stop"
      (click)="deactivateSwipe()"
      title="Stop comparing"
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
      >
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
      Stop
    </button>
    <span class="cv-swipe-bar__name cv-swipe-bar__name--right">
      {{ swipeLayerNames(swipeRightIds()) }}
      <svg viewBox="0 0 8 8">
        <circle cx="4" cy="4" r="3" fill="currentColor" />
      </svg>
    </span>
  </div>

  <!-- Draggable divider line -->
  <div
    *ngIf="swipeActive()"
    class="cv-swipe-divider"
    [style.left.%]="swipePosition() * 100"
    (mousedown)="onSwipeDragStart($event)"
    (touchstart)="onSwipeDragStart($event)"
  >
    <div class="cv-swipe-divider__line"></div>
    <div class="cv-swipe-divider__handle" aria-label="Drag to compare">
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
      >
        <polyline points="15 18 9 12 15 6" />
      </svg>
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
      >
        <polyline points="9 18 15 12 9 6" />
      </svg>
    </div>
  </div>

  <lib-canvas-datasets-modal
    [isOpen]="isDatasetsModalOpen()"
    (closeModal)="isDatasetsModalOpen.set(false)"
    (startBboxSearch)="onDatasetsBboxSearch()"
    (startBboxFilter)="onDatasetsBboxFilter($event)"
    (startGetAll)="onDatasetsGetAll($event)"
    (startAttrFilter)="onDatasetsAttrFilter($event)"
    (startStacList)="onDatasetsStacList($event)"
    (startLoadTiles)="onDatasetsLoadTiles($event)"
  ></lib-canvas-datasets-modal>

  <lib-canvas-bbox-results-modal
    [isOpen]="isBboxResultsModalOpen()"
    [hits]="bboxSearchHits()"
    [datasets]="datasetsService.datasets()"
    [selectedResourceIds]="selectedBboxResourceIds()"
    (closeModal)="closeBboxResultsModal()"
    (startBboxFilter)="onBboxResultStartFilter($event)"
    (startGetAll)="onBboxResultStartGetAll($event)"
    (startAttrFilter)="onBboxResultAttrFilter($event)"
    (startStacList)="onBboxResultStacList($event)"
    (startLoadTiles)="onBboxResultLoadTiles($event)"
  ></lib-canvas-bbox-results-modal>

  <lib-canvas-stac-list-modal
    [open]="isStacModalOpen()"
    [dataset]="stacDataset()"
    (close)="closeStacModal()"
    (plot)="onStacPlot($event)"
  ></lib-canvas-stac-list-modal>

  <lib-canvas-attr-filter-modal
    [open]="isAttrFilterModalOpen()"
    [dataset]="attrFilterDataset()"
    (apply)="onAttrFilterApply($event)"
    (close)="closeAttrFilterModal()"
  ></lib-canvas-attr-filter-modal>

  <!-- Feature Properties Sidebar -->
  <div
    class="cv-prop-sidebar"
    [class.cv-prop-sidebar--open]="isSidebarOpen()"
    role="complementary"
    aria-label="Feature properties"
  >
    <div class="cv-prop-sidebar__header">
      <div class="cv-prop-sidebar__title-wrap">
        <span class="cv-prop-sidebar__eyebrow">Map</span>
        <h3 class="cv-prop-sidebar__title">Feature details</h3>
      </div>
      <button
        class="cv-prop-sidebar__close"
        type="button"
        (click)="closeSidebar()"
        aria-label="Close properties panel"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
        <span>Close</span>
      </button>
    </div>
    <div class="cv-prop-sidebar__body" *ngIf="sidebarProperties() as props">
      <table class="cv-prop-table">
        <thead>
          <tr>
            <th class="cv-prop-table__hdr">Property</th>
            <th class="cv-prop-table__hdr">Value</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let entry of objectEntries(props)"
            class="cv-prop-table__row"
          >
            <td class="cv-prop-table__key" [title]="entry[0]">
              {{ entry[0] }}
            </td>
            <td class="cv-prop-table__val">
              <pre class="cv-prop-table__pre">{{ formatPropValue(entry[1]) }}</pre>
            </td>
          </tr>
          <tr *ngIf="objectEntries(props).length === 0" class="cv-prop-table__row">
            <td class="cv-prop-table__val" colspan="2">This feature has no attributes.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Layer export dialog (ui-canvas LayerMorePopover parity) -->
  <div
    *ngIf="layerExportDialogOpen()"
    class="cv-import-dialog-backdrop"
    (click)="closeLayerExportDialog()"
  >
    <div
      class="cv-export-dialog cv-export-dialog--layer"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cv-layer-export-title"
      (click)="$event.stopPropagation()"
    >
      <h2 id="cv-layer-export-title" class="cv-export-dialog__title">Export layer</h2>
      <div class="cv-export-dialog__form">
        <label class="cv-export-dialog__field">
          <span class="cv-export-dialog__field-label">Name</span>
          <input
            type="text"
            [value]="layerExportFileName"
            (input)="onLayerExportNameInput($event)"
            placeholder="Layer name"
            autocomplete="off"
          />
        </label>
        <div class="cv-export-dialog__format">
          <span class="cv-export-dialog__format-label">Export as</span>
          <span class="cv-export-dialog__format-value">geojson</span>
        </div>
      </div>
      <div class="cv-export-dialog__actions">
        <button
          type="button"
          class="cv-export-dialog__btn cv-export-dialog__btn--cancel"
          (click)="closeLayerExportDialog()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="cv-export-dialog__btn cv-export-dialog__btn--export"
          [disabled]="!canConfirmLayerExport()"
          (click)="confirmLayerExport()"
        >
          Export
        </button>
      </div>
    </div>
  </div>
  <a #layerExportAnchor class="cv-tb-export-anchor" tabindex="-1" aria-hidden="true"></a>
</div>
